<template>
  <div>
    <v-row>
      <v-col cols="12" md="2">
        <v-skeleton-loader
          v-if="!dataLoaded"
          type="card"
          height="150"
        ></v-skeleton-loader>
        <TotalCard
          v-else
          :label="$t('totalItems')"
          :count="totalItems"       
        />
      </v-col>
      <v-col cols="12" md="2">
        <v-skeleton-loader
          v-if="!dataLoaded"
          type="card"
          height="150"
        ></v-skeleton-loader>
        <TotalCard
          v-else
          :label="$t('totalSubItems')"
          :tooltip="$t('totalSubItemsTooltip')" 
          :count="totalSubItems"   
        />  
      </v-col>
      <v-col cols="12" md="3">
        <v-skeleton-loader
          v-if="!dataLoaded"
          type="card"
          height="150"
        ></v-skeleton-loader>
        <TotalCardWithSwitch
          v-else
          identifier="totalControlledByMyTeams"
          :label="$t('controlledByYourTeams')"
          :count="totalControlledByYourTeams"
          @filter-change="handleFilterChange"
          v-model:selected="filterByControlledByMyTeams"   
        />  
      </v-col>
      <v-col cols="12" md="3">
        <v-skeleton-loader
          v-if="!dataLoaded"
          type="card"
          height="150"
        ></v-skeleton-loader>
        <TotalCardWithSwitch
          v-else
          identifier="totalCreatedByYourTeams"
          :label="$t('createdByYourTeams')"
          :count="totalCreatedByYourTeams"
          @filter-change="handleFilterChange"
          v-model:selected="filterByCreatedByMyTeams"   
        /> 
      </v-col>
      <v-col cols="12" md="2">
        <v-skeleton-loader
          v-if="!dataLoaded"
          type="card"
          height="150"
        ></v-skeleton-loader>
        <TotalCardWithSwitch
          v-else
          identifier="totalCreatedByYou"
          :label="$t('createdByYou')"
          :count="totalCreatedByYou"
          @filter-change="handleFilterChange"
          v-model:selected="filterByCreatedByYou"   
        /> 
      </v-col>
    </v-row>

    <v-row>        
      <v-col cols="12" md="8">
        <StackedHorizontalBarChart
          :title="$t('itemBreakdown')"
          :exportFilename="$t('itemBreakdown') + '.png'"
          v-bind="controllerCategoryChart"
          :filterContext="filterContext"
          :chartFontColor="chartFontColor"
          :dataLoaded="dataLoaded"
        />
      </v-col>
      <v-col cols="12" md="4">
        <BaseDonutChart
          :title="$t('controllerBreakdown')"
          :exportFilename="$t('controllerBreakdown') + '.png'"
          :series-name="$t('teamDistribution')"
          :dataProvider="controllerDonutChart.getTeamDistribution"
          :onSelect="controllerDonutChart.setTeamFilter"
          :filterContext="filterContext"
          :chartFontColor="chartFontColor"
          :dataLoaded="dataLoaded"
        />
      </v-col>
    </v-row>

    <!-- Items Data Table -->
    <v-row>
      <v-col cols="12" md="12">
        <ItemsGrid v-bind="grid" />
      </v-col>
    </v-row>
  </div>
</template>

<script src="./model.js"></script>
<style src="./style.css" scoped></style>
